import { Link } from "react-router-dom";
import NewsletterForm from "@/components/feature/NewsletterForm";

export default function SubscribeSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-foreground-950">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-14 items-center">
        <div>
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/40 text-xs text-primary-100 mb-5">
            <i className="ri-mail-send-line"></i>
            翻车速递 · 每周一封
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-background-50 leading-tight">
            不想刷半天，就让事件自己找上门
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200 max-w-xl">
            我们把本周新增的翻车事件、名场面回放和关键截图整理成一封邮件。
            没有标题党，只有经过、画面和复盘。
          </p>
          <div className="mt-6 flex flex-wrap gap-x-6 gap-y-3">
            <span className="flex items-center gap-2 text-sm text-background-200">
              <i className="ri-check-line text-accent-400"></i>
              只发已核实事件
            </span>
            <span className="flex items-center gap-2 text-sm text-background-200">
              <i className="ri-check-line text-accent-400"></i>
              随时可退订
            </span>
            <span className="flex items-center gap-2 text-sm text-background-200">
              <i className="ri-check-line text-accent-400"></i>
              不用于任何推广
            </span>
          </div>
        </div>

        <div className="rounded-lg bg-background-50 p-5 md:p-7">
          <h3 className="font-heading font-semibold text-lg text-foreground-950">订阅翻车速递</h3>
          <p className="mt-1.5 text-sm text-foreground-600 mb-5">
            填写邮箱即可，下一期发出前还能一键退订。
          </p>
          <NewsletterForm />
          <div className="mt-5 pt-5 border-t border-background-200 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <Link to="/about" className="hover:text-primary-600 transition-colors whitespace-nowrap">
              了解我们怎么选题
            </Link>
            <Link to="/contact" className="hover:text-primary-600 transition-colors whitespace-nowrap">
              提供事件线索
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}